import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import "@/pages/landing.css";

const POINTS = [
  "Launch your store in minutes",
  "100+ themes or generate one with AI",
  "Accept payments, manage orders, track sales",
  "Mobile-ready storefront, 24x7 support",
];

// Split-screen layout shared by /login and /signup, matching the landing page theme.
export default function AuthShell({ children, wide = false }) {
  return (
    <div className="lp min-h-screen grid lg:grid-cols-[minmax(0,5fr)_minmax(0,6fr)] font-['Plus_Jakarta_Sans',Inter,sans-serif]">
      {/* Brand panel */}
      <aside className="relative hidden lg:flex flex-col justify-between overflow-hidden px-12 py-10 text-white bg-gradient-to-br from-black via-neutral-950 to-blue-950">
        <div className="lp-blob absolute -right-24 -top-24 w-96 h-96 rounded-full bg-blue-600/30 blur-3xl" />
        <div className="lp-blob absolute -left-20 bottom-10 w-80 h-80 rounded-full bg-orange-500/15 blur-3xl" />
        <Link to="/" className="relative"><img src="/logo-dark.png" alt="sell24x7.com" className="h-14 w-auto" /></Link>
        <div className="relative">
          <motion.h2 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
            className="font-display text-4xl xl:text-5xl font-extrabold leading-tight tracking-tight">
            Your Online Store<br /><span className="text-blue-400">in Minutes.</span>
          </motion.h2>
          <p className="mt-4 text-sm text-slate-300 max-w-sm leading-relaxed">
            Everything you need &mdash; website, payments, delivery, marketing and more &mdash; in one affordable platform.
          </p>
          <ul className="mt-7 space-y-3">
            {POINTS.map((p, i) => (
              <motion.li key={p} initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.3 + i * 0.12 }}
                className="flex items-center gap-2.5 text-sm text-slate-200">
                <CheckCircle2 size={17} className="text-green-400 shrink-0" />{p}
              </motion.li>
            ))}
          </ul>
        </div>
        <div className="relative text-xs text-slate-500">&copy; 2026 Sell24x7 &mdash; Your eCom Street.</div>
      </aside>

      {/* Form panel */}
      <main className="relative flex items-center justify-center px-6 py-10 bg-gradient-to-b from-blue-50/70 via-white to-white overflow-hidden">
        <div className="lp-blob absolute -right-24 -top-16 w-72 h-72 rounded-full bg-blue-200/50 blur-3xl" />
        <div className={`relative w-full ${wide ? "max-w-2xl" : "max-w-md"}`}>
          <Link to="/" className="flex justify-center mb-6 lg:hidden"><img src="/logo-light.png" alt="sell24x7.com" className="h-11 w-auto" /></Link>
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
            className="rounded-xl bg-white border border-slate-200 shadow-[0_20px_60px_rgba(37,99,235,0.10)] p-6">
            {children}
          </motion.div>
        </div>
      </main>
    </div>
  );
}
